
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Link1',
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    }
  },
  setup() {
  },
})
